import { CustomTable } from 'common/components/table/customTable';
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table';
import { getDataScienceTasksColumnDefs } from './tasks-column-defs';
import { FC } from 'react';
import { DataScienceTask } from '../tasks.models';

interface DataScienceTasksTableProps {
  dataScienceTasks: DataScienceTask[];
}

export const DataScienceTasksTable: FC<DataScienceTasksTableProps> = ({
  dataScienceTasks
}) => {
  const columnDefs = getDataScienceTasksColumnDefs();

  const dataScienceTasksTable = useReactTable({
    data: dataScienceTasks,
    columns: columnDefs,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    enableColumnResizing: true,
    debugTable: false,
    debugHeaders: false,
    debugColumns: false
  });

  return (
    <>
      <CustomTable
        key={`dataScienceTasks-table`}
        componentId={'dataScienceTasks-table'}
        table={dataScienceTasksTable}
        cellClasses=""
        overflowClass=""
      />
    </>
  );
};
export default DataScienceTasksTable;
